<template>
  <v-app id="search">
    <v-dialog
      :value="authModalShow"
      content-class="login-modal"
      :overlay-color="'#333'"
      :overlay-opacity="0.8"
      persistent
    >
      <Login
        v-if="authModalShow == 'LOGIN'"
        :dialogView="true"
        @close-modal="authModalShow = null"
        @show-register="(authModalShow = 'REGISTER'), (fromLogin = true)"
        @reset-password="authModalShow = 'RESETPASSWORD'"
      />
      <Register
        v-else-if="authModalShow == 'REGISTER'"
        :dialogView="true"
        :fromLogin="fromLogin"
        @close-modal="(authModalShow = null), (fromLogin = false)"
        @show-login="(authModalShow = 'LOGIN'), (fromLogin = false)"
      />
      <ResetPassword
        v-else-if="authModalShow == 'RESETPASSWORD'"
        :dialogView="true"
        @close-modal="authModalShow = 'LOGIN'"
      />
    </v-dialog>
    <a
      class="white--text ml-auto mr-3 mt-3 signin-link d-block d-sm-none text-right"
      v-if="user"
      ><small>{{ userInfo }}</small
      ><br />
      <span class="v-underline" @click="logout"> Sign out ></span>
    </a>
    <a
      @click="login"
      class="v-underline ml-auto mr-3 mt-3 white--text signin-link d-block d-sm-none"
      v-else
      >Sign in >
    </a>
    <div id="ZN_0VRSjErncaDKLL8"><!--DO NOT REMOVE-CONTENTS PLACED HERE--></div>
    <router-view />
  </v-app>
</template>

<script>
import Login from "@/views/pace-auth/Login";
import Register from "@/views/pace-auth/Register";
import ResetPassword from "@/views/pace-auth/ResetPassword";
import { mapActions, mapGetters } from "vuex";
import userInfoDisplayMixin from "@/mixins/userInfoDisplayMixin";

export default {
  name: "Greetinglayout",

  mixins: [userInfoDisplayMixin],

  components: {
    Login,
    Register,
    ResetPassword,
  },
  data() {
    return {
      fromLogin: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters(["authModal"]),
    authModalShow: {
      get() {
        return this.authModal;
      },
      set(val) {
        this.toggleAuthModal(val);
      },
    },
  },
  methods: {
    ...mapActions(["toggleAuthModal"]),
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      window.location.reload();
    },
    login() {
      this.toggleAuthModal("LOGIN");
    },
  },
  mounted() {
    (function () {
      let g = function (e, h, f, g) {
        this.get = function (a) {
          for (
            let a = a + "=",
              c = document.cookie.split(";"),
              b = 0,
              e = c.length;
            b < e;
            b++
          ) {
            let d = c[b];
            for (d; " " == d.charAt(0); ) d = d.substring(1, d.length);
            if (0 == d.indexOf(a)) return d.substring(a.length, d.length);
          }
          return null;
        };

        this.set = function (a, c) {
          let b = "";
          b = new Date();
          b.setTime(b.getTime() + 6048e5);
          b = "; expires=" + b.toGMTString();
          document.cookie = a + "=" + c + b + "; path=/; ";
        };

        this.check = function () {
          var a = this.get(f);
          if (a) a = a.split(":");
          else if (100 != e)
            "v" == h && (e = Math.random() >= e / 100 ? 0 : 100),
              (a = [h, e, 0]),
              this.set(f, a.join(":"));
          else return !0;
          var c = a[1];
          if (100 == c) return !0;
          switch (a[0]) {
            case "v":
              return !1;
            case "r":
              return (
                (c = a[2] % Math.floor(100 / c)),
                a[2]++,
                this.set(f, a.join(":")),
                !c
              );
          }
          return !0;
        };

        this.go = function () {
          if (this.check()) {
            var a = document.createElement("script");
            a.type = "text/javascript";
            a.src = g;
            document.body && document.body.appendChild(a);
          }
        };

        this.start = function () {
          console.log('starting ...')
          var t = this;
          "complete" !== document.readyState
            ? window.addEventListener
              ? window.addEventListener(
                  "load",
                  function () {
                    t.go();
                  },
                  !1
                )
              : window.attachEvent &&
                window.attachEvent("onload", function () {
                  t.go();
                })
            : t.go();
        };
      };

      try {
        new g(
          100,
          "r",
          "QSI_S_ZN_0VRSjErncaDKLL8",
          "https://zn0vrsjerncadkll8-qutc.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_0VRSjErncaDKLL8"
        ).start();
      } catch (i) {}
    })();
  },
};
</script>
<style lang="scss">
#search {
  background: #939597;
}

@media (max-width: 600px) {
  #search {
    background: #012A4C;// #f15f35;
    position: relative;
    .v-application--wrap {
      z-index: 1;
    }
  }

  #search::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: url("../../assets/IPEPA_Artwork_White_RGB.png");
    background-size: 500px 500px;
    background-position: -200px -200px;
    background-repeat: no-repeat;
    opacity: 0.6;
  }
}
</style>
